import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { HeaderService } from '@/services/header-service.interface';

export const HeaderServiceProxy = Symbol('HeaderServiceProxy');

export interface HeaderServiceProxy {
    headerService: HeaderService;
}

@injectable()
export class HeaderServiceProxyImpl implements HeaderServiceProxy {
    constructor(
        @inject(HeaderService)
        public headerService: HeaderService
    ) {
        this.headerService.visibleProducts = false;
        this.headerService.deferred.promise
            .then(() => {
                this.headerService.visibleProducts = true;
            });
    }
}
